// Fehlertolerante Artikelsuche (wie bei abf.store): Bezeichnungen werden ohne Punkt,
// Bindestrich, Schraegstrich und Leerzeichen verglichen, "6205 2rs", "62052RS" und
// "6205-2RS" finden also denselben Artikel.
// Quelle ist der Suchindex aus den Shopify-Dateien (URL im Shop-Metafeld mbs.suchindex, als window.mbSuche.index, gebaut von
// ueb/suche/index-bauen.js). Er wird erst beim ersten Fokus auf ein Suchfeld geladen.
// - Vorschlagsliste unter jedem Suchfeld: mit Ziffer im Suchbegriff aus dem Index,
//   reine Wortsuche ("Dichtung") ueber Shopifys /search/suggest.json.
// - Suchseite: mit Ziffer im Suchbegriff ersetzt der Index die Shopify-Treffer, die Zeilen
//   liefert der Abschnitt main-search-liste (q=mbh:handle1 handle2 ..., 20 je Seite).
(function () {
  var cfg = window.mbSuche || {};
  if (!cfg.index) return;
  var T = cfg.texte || {};
  var basis = String(cfg.root || '/').replace(/\/$/, '');
  var daten = null;
  var laden = null;

  function norm(s) {
    return String(s || '').toUpperCase()
      .replace(/Ä/g, 'A').replace(/Ö/g, 'O').replace(/Ü/g, 'U').replace(/ß/g, 'SS')
      .replace(/[^A-Z0-9]/g, '');
  }
  function slug(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function mitZiffer(q) { return /\d/.test(q); }

  function indexLaden() {
    if (!laden) {
      laden = fetch(cfg.index).then(function (r) {
        if (!r.ok) throw new Error('Suchindex ' + r.status);
        return r.text();
      }).then(function (txt) {
        var z = txt.split('\n');
        var fab = z[1].split('\t');
        var d = { t: [], v: [], h: [], k: [], kv: [] };
        for (var i = 2; i < z.length; i++) {
          if (!z[i]) continue;
          var f = z[i].split('\t');
          var vendor = fab[+f[1]] || '';
          var n = norm(f[0]);
          d.t.push(f[0]);
          d.v.push(vendor);
          d.h.push(f[2] || slug(f[0]));
          d.k.push(n);
          d.kv.push(norm(vendor) + n);
        }
        daten = d;
        return d;
      });
      laden.catch(function () { laden = null; });
    }
    return laden;
  }

  // Reihenfolge: exakt, beginnt mit (auch "SKF 6205" = Fabrikat + Bezeichnung), enthaelt.
  // Zuletzt: alle eingegebenen Teile in dieser Reihenfolge, mit Zusaetzen dazwischen
  // ("6205 2rs c3" findet auch 6205-2RS1/C3).
  // Innerhalb einer Stufe kuerzere Bezeichnung zuerst, dann alphabetisch.
  function suchen(q) {
    var Q = norm(q);
    if (Q.length < 2) return [];
    var teile = String(q).split(/[^0-9A-Za-zÄÖÜäöüß]+/).map(norm).filter(Boolean);
    var inReihe = function (n) {
      var pos = 0;
      for (var j = 0; j < teile.length; j++) {
        pos = n.indexOf(teile[j], pos);
        if (pos < 0) return false;
        pos += teile[j].length;
      }
      return true;
    };
    var genau = [], anfang = [], drin = [], verteilt = [];
    for (var i = 0; i < daten.k.length; i++) {
      var n = daten.k[i];
      if (n === Q || daten.kv[i] === Q) genau.push(i);
      else if (n.indexOf(Q) === 0 || daten.kv[i].indexOf(Q) === 0) anfang.push(i);
      else if (Q.length >= 3 && n.indexOf(Q) > 0) drin.push(i);
      else if (teile.length > 1 && (inReihe(n) || inReihe(daten.kv[i]))) verteilt.push(i);
    }
    var nachLaenge = function (a, b) {
      return daten.k[a].length - daten.k[b].length || (daten.k[a] < daten.k[b] ? -1 : 1);
    };
    anfang.sort(nachLaenge);
    drin.sort(nachLaenge);
    verteilt.sort(nachLaenge);
    return genau.concat(anfang, drin, verteilt);
  }

  // ---------- Vorschlagsliste ----------
  var css = document.createElement('style');
  css.textContent =
    '.mb-vorschlag{position:absolute;left:0;top:100%;z-index:60;width:max(100%,min(38rem,92vw));margin-top:4px;background:#fff;color:#0e1b4d;' +
    'border:1px solid rgba(14,27,77,.15);border-radius:8px;box-shadow:0 8px 24px rgba(14,27,77,.18);overflow:hidden;text-align:left;font-size:1.4rem;line-height:1.3}' +
    '.mb-vorschlag a{display:flex;gap:1.2rem;align-items:baseline;padding:.8rem 1.2rem;color:inherit;text-decoration:none}' +
    '.mb-vorschlag a:hover,.mb-vorschlag a.mb-aktiv{background:rgba(14,27,77,.07)}' +
    '.mb-vorschlag__marke{flex:0 0 9rem;font-size:1.05rem;letter-spacing:.06em;text-transform:uppercase;opacity:.6;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.mb-vorschlag__titel{font-weight:600}' +
    '.mb-vorschlag__alle{border-top:1px solid rgba(14,27,77,.1);font-weight:600;justify-content:center}' +
    '.mb-vorschlag__leer{padding:.9rem 1.2rem;opacity:.65}' +
    '.mb-sucht .mb-scroll,.mb-sucht .mb-blaettern,.mb-sucht .mb-keine{visibility:hidden}' +
    '.mb-sucht .mb-anzahl::after{content:attr(data-laedt)}';
  document.head.appendChild(css);

  function eintragHtml(href, marke, titel) {
    return '<a href="' + esc(href) + '" role="option"><span class="mb-vorschlag__marke">' + esc(marke) +
      '</span><span class="mb-vorschlag__titel">' + esc(titel) + '</span></a>';
  }

  function anbinden(input) {
    if (input.dataset.mbSuche) return;
    input.dataset.mbSuche = '1';
    // Such-Overlay im Kopf: dort haengt noch Shopifys <predictive-search>. Dessen Eingabe-
    // Ereignis wird in der Capture-Phase abgefangen, damit nur diese Vorschlagsliste erscheint.
    var shopifyVorschlag = input.closest('predictive-search');
    input.setAttribute('autocomplete', 'off');
    var form = input.form;
    var halter = input.closest('.field') || form;
    if (getComputedStyle(halter).position === 'static') halter.style.position = 'relative';
    var box = document.createElement('div');
    box.className = 'mb-vorschlag';
    box.setAttribute('role', 'listbox');
    box.hidden = true;
    halter.appendChild(box);
    var zaehler = 0, timer = null;

    function zeigen(html) {
      box.innerHTML = html;
      box.hidden = !html;
    }
    function alleLink(n) {
      var text = (T.alle || 'Alle {n} Treffer anzeigen').replace(n == null ? '{n} ' : '{n}', n == null ? '' : n);
      return '<a href="#" class="mb-vorschlag__alle" data-alle>' + esc(text) + '</a>';
    }
    function aktualisieren() {
      var q = input.value.trim();
      var nr = ++zaehler;
      if (q.length < 2) { zeigen(''); return; }
      if (mitZiffer(q)) {
        indexLaden().then(function () {
          if (nr !== zaehler) return;
          var treffer = suchen(q);
          if (!treffer.length) { zeigen('<div class="mb-vorschlag__leer">' + esc(T.keine || '') + '</div>'); return; }
          zeigen(treffer.slice(0, 8).map(function (i) {
            return eintragHtml(basis + '/products/' + daten.h[i], daten.v[i], daten.t[i]);
          }).join('') + alleLink(treffer.length));
        }).catch(function () { zeigen(''); });
      } else {
        fetch(basis + '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (nr !== zaehler) return;
            var p = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!p.length) { zeigen('<div class="mb-vorschlag__leer">' + esc(T.keine || '') + '</div>'); return; }
            zeigen(p.map(function (x) { return eintragHtml(x.url, x.vendor || '', x.title); }).join('') + alleLink(null));
          }).catch(function () { zeigen(''); });
      }
    }

    input.addEventListener('focus', function () { indexLaden(); if (input.value.trim().length >= 2) aktualisieren(); });
    var beiEingabe = function () { clearTimeout(timer); timer = setTimeout(aktualisieren, 120); };
    if (shopifyVorschlag) {
      shopifyVorschlag.addEventListener('input', function (e) {
        if (e.target !== input) return;
        e.stopPropagation();
        beiEingabe();
      }, true);
    } else {
      input.addEventListener('input', beiEingabe);
    }
    input.addEventListener('keydown', function (e) {
      var links = [].slice.call(box.querySelectorAll('a'));
      if (box.hidden || !links.length) return;
      var akt = links.indexOf(box.querySelector('a.mb-aktiv'));
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (akt >= 0) links[akt].classList.remove('mb-aktiv');
        akt = e.key === 'ArrowDown' ? (akt + 1) % links.length : (akt <= 0 ? links.length - 1 : akt - 1);
        links[akt].classList.add('mb-aktiv');
      } else if (e.key === 'Enter' && akt >= 0) {
        e.preventDefault();
        links[akt].click();
      } else if (e.key === 'Escape') {
        zeigen('');
      }
    });
    box.addEventListener('mousedown', function (e) { e.preventDefault(); });
    box.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      if (a.hasAttribute('data-alle')) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
    input.addEventListener('blur', function () { setTimeout(function () { zeigen(''); }, 150); });
  }

  function alleFelder() {
    document.querySelectorAll('form[action$="/search"] input[name="q"]').forEach(anbinden);
  }

  // ---------- Suchseite ----------
  function seitenNav(seite, seiten, q) {
    if (seiten < 2) return '';
    var link = function (s) { return basis + '/search?q=' + encodeURIComponent(q) + '&type=product&seite=' + s; };
    var teile = [];
    for (var s = 1; s <= seiten; s++) {
      if (s === 1 || s === seiten || Math.abs(s - seite) <= 2) teile.push(s);
      else if (teile[teile.length - 1] !== 0) teile.push(0);
    }
    var html = '<nav class="mb-seiten" aria-label="' + esc(T.seite || '') + '"><span class="mb-seiten-titel">' + esc(T.seite || '') + '</span>';
    html += seite > 1 ? '<a class="mb-pfeilbtn" href="' + link(seite - 1) + '" aria-label="' + esc(T.vorherige || '') + '">&#9665;</a>'
      : '<span class="mb-pfeilbtn mb-aus" aria-hidden="true">&#9665;</span>';
    teile.forEach(function (s) {
      if (s === 0) html += '<span class="mb-luecke" aria-hidden="true">&hellip;</span>';
      else if (s === seite) html += '<span class="mb-seite mb-seite-aktiv" aria-current="page">' + s + '</span>';
      else html += '<a class="mb-seite" href="' + link(s) + '">' + s + '</a>';
    });
    html += seite < seiten ? '<a class="mb-naechste" href="' + link(seite + 1) + '">' + esc(T.naechste || '') + ' <span aria-hidden="true">&#9655;</span></a>'
      : '<span class="mb-naechste mb-aus">' + esc(T.naechste || '') + ' <span aria-hidden="true">&#9655;</span></span>';
    html += '<span class="mb-seiten-von">' + esc((T.von_seiten || '').replace('{n}', seiten)) + '</span></nav>';
    return html;
  }

  function suchseite() {
    var wrap = document.querySelector('[data-mb-suchseite]');
    if (!wrap) return;
    var params = new URLSearchParams(location.search);
    var q = (params.get('q') || '').trim();
    if (!mitZiffer(q) || q.indexOf('mbh:') === 0) { wrap.classList.remove('mb-sucht'); return; }
    var anzahl = wrap.querySelector('.mb-anzahl');
    if (anzahl) anzahl.setAttribute('data-laedt', T.laedt || '');
    wrap.classList.add('mb-sucht');
    var fertig = function () { wrap.classList.remove('mb-sucht'); };
    setTimeout(fertig, 10000);

    indexLaden().then(function () {
      var treffer = suchen(q);
      if (!treffer.length) { fertig(); return; }
      var pro = +wrap.dataset.proSeite || 20;
      var seiten = Math.ceil(treffer.length / pro);
      var seite = Math.min(Math.max(1, parseInt(params.get('seite'), 10) || 1), seiten);
      var handles = treffer.slice((seite - 1) * pro, seite * pro).map(function (i) { return daten.h[i]; });
      var url = basis + '/search?type=product&section_id=' + encodeURIComponent(wrap.dataset.sektion) +
        '&q=' + encodeURIComponent('mbh:' + handles.join(' '));
      return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neu = doc.querySelector('.mb-liste tbody');
        var tbody = wrap.querySelector('.mb-liste tbody');
        if (!neu || !tbody) { fertig(); return; }
        tbody.innerHTML = neu.innerHTML;
        wrap.querySelector('.mb-scroll').hidden = false;
        var keine = wrap.querySelector('.mb-keine');
        if (keine) keine.hidden = true;
        if (anzahl) anzahl.textContent = (anzahl.dataset.nText || '{n}').replace('{n}', treffer.length);
        var sort = wrap.querySelector('#mb-sortierung');
        if (sort) { sort.hidden = true; var l = wrap.querySelector('label[for="mb-sortierung"]'); if (l) l.hidden = true; }
        var nav = wrap.querySelector('.mb-blaettern');
        if (nav) nav.innerHTML = seitenNav(seite, seiten, q);
        fertig();
      });
    }).catch(fertig);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alleFelder(); suchseite(); });
  } else {
    alleFelder();
    suchseite();
  }
})();
